import Vue from 'vue'
import Vuex from 'vuex'
import breadCrumb from './breadCrumb'
import newBreadCrumb from './backBreadCrumb' // 引入新的面包屑模块

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用于登录成功后 保存用户信息(初始值尝试读取本地存储)
    // JSON.parse 将本地存储的字符串信息转换为 对象 Object
    user: JSON.parse(window.localStorage.getItem('user_scnu')) || null,
    // 测试数据 用来模拟后台
    // login_return: { data: { code: 200, msg: '成功登录', userInfo: '234214121234ADDF', role: 'teacher' } }
    // 用来传递排课表的课程信息
    courseParams: null,
    // 用来传递的学生查询的参数
    studentParams: null,
    // 新生参数
    isNewStudent: null,
    isCollapse: false, // 状态栏状态
    isMenuActive: false, // 学生端状态栏状态
    isShowEnrollment: JSON.parse(localStorage.getItem('isShowEnrollment')) || true // 是否开启申报招生计划
  },
  getters: {},
  mutations: {
    setStuTabstatus (state, status) {
      state.isMenuActive = status
    },
    setTabStatus (state, status) {
      state.isCollapse = status
    },
    // 存储用户数据
    setUser (state, payload) {
      // 将 payload 转换为对象后再存储
      state.user = payload
      //  将 payload 数据添加到本地存储中
      // JSON.stringify 将对象转换为 JSON 字符串，然后存储到本地内存中
      window.localStorage.setItem('user_scnu', JSON.stringify(payload))
      // console.log(JSON.parse(window.localStorage.getItem('user_scnu')))
    },
    // 清除用户数据
    clearUser (state) {
      state.user = null
      window.localStorage.removeItem('user_scnu')
    },
    setCourseParams (state, payload) {
      state.courseParams = payload
    },
    clearCourseParams (state) {
      state.courseParams = null
    },
    setStudentParams (state, payload) {
      state.studentParams = payload
    },
    clearStudentParams (state) {
      state.studentParams = null
    },
    setNewStudent (state, payload) {
      state.isNewStudent = payload
    },
    clearNewStudent (state) {
      state.isNewStudent = null
    },
    setIsShowEnrollment (state, value) {
      state.isShowEnrollment = value
      localStorage.setItem('isShowEnrollment', JSON.stringify(value))
    }
  },
  actions: {
    updateIsShowEnrollment ({ commit }, value) {
      console.log('Updating isShowEnrollment to:', value)
      commit('setIsShowEnrollment', value)
    }
  },
  modules: {
    breadCrumb, // 原始的面包屑模块
    newBreadCrumb // 新的面包屑模块
  }
})
